import React, { useState, useEffect, useContext } from "react";

import lbl from "../../../data/Labels.json";
import Img from "../../common/Img";
import db from "../../../services/query";
import { PopUpContext } from "../../../contexts/popUpContext";
import ReportItemHeader from "../../common/ReportItemHeader";
import MainPrintLink from "../../common/MainPrint";

import ContractsList from "./ContractsList";
import MainButton from "../../common/MainButton";


const ContractsProfile = (props) => {
  const { sid } = props.match.params;
  const { togglePopUp, popUp } = useContext(PopUpContext);

  const [data, updateData] = useState([]);

  useEffect(async () => {
    const ac = new AbortController();

    requestData();

    return () => ac.abort();
  }, [popUp]);

  const requestData = async () => {
    let query = `teachers/${sid}/contracts`;

    await db.getAll(query).then(({ data }) => {
      updateData(data);
    });
  };

  return (
    <React.Fragment>
      <div className="finance-profile-area">
        <div className="std-profile">
          <div className="wrapper">
            <Img src={data?.summary?.staff_photo} border={true} />
          </div>
        </div>
        <div className="overall-summary">
          <div className="wrapper"></div>
        </div>
        <div className="controls">
          <MainButton
              type="add"
              title={lbl.AddContract}
              handleClick={() => togglePopUp({ form: "teacher-contract-form", cache: sid})}
          />
        </div>
      </div>
      <div className="finance-report-area">
        <div className="report-container" style={{width: "100%"}}>
          <ReportItemHeader title={lbl.Details} />
          <div className="report-table-area">
            <ContractsList  data={data && data}/>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ContractsProfile;
